import { render } from "./FittersOverview.vue?vue&type=template&id=0488ae36&scoped=true"
import script from "./FittersOverview.vue?vue&type=script&lang=js"
export * from "./FittersOverview.vue?vue&type=script&lang=js"

import "./FittersOverview.vue?vue&type=style&index=0&id=0488ae36&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0488ae36"]])

export default __exports__